import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/otp';

function fetchOtpSuccess(state, action) {
  const { code, message } = action.payload;

  state.fetchOtp = {
    success: true,
    error: false,
    code,
    message,
  };
}

function fetchOtpError(state, action) {
  const { code, message } = action.payload;
  state.fetchOtp = {
    success: false,
    error: true,
    code,
    message,
  };
}

function validateOtpSuccess(state, action) {
  const { code, message } = action.payload;
  state.validateOtp = {
    success: true,
    error: false,
    code,
    message,
  };
}

function validateOtpError(state, action) {
  const { code, message } = action.payload;
  state.validateOtp = {
    success: false,
    error: true,
    code,
    message,
  };
}

const fetchOtp = createAction('fetchOtp');
const validateOtp = createAction('validateOtp');

const otpReducer = createSlice({
  name: 'otp',
  initialState,
  reducers: {
    fetchOtpSuccess,
    fetchOtpError,
    validateOtpSuccess,
    validateOtpError,
  },
});

export const otpActions = {
  ...otpReducer.actions,
  fetchOtp,
  validateOtp,
};

export default otpReducer.reducer;
